<template>
    <!-- 对话框 -->
    <el-drawer title="发货配置" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 85vh">
                <el-form-item label="用户选择礼包:" label-width="120px">
                    {{prize}}
                </el-form-item>
                <el-form-item label="快递公司:" label-width="120px">
                    <el-select v-model="submit_data.express" placeholder="请选择" clearable>
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="快递单号:" label-width="120px">
                    <el-input v-model="submit_data.express_no"
                              style="width: 50%">
                    </el-input>
                </el-form-item>

            </el-form>
            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center">
                <submitBtn
                        :data="submit_data"
                        :rules="submit_rules"
                        url="/activeprize/sendPrize"
                        @onSubmitDig="onSubmitDig"
                />

                <el-button @click="closeDialog">返回</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
    import { config } from '../../../utils/config';

    var _this;
    import axios from 'axios'; // AJAX封装类
    export default {
        props: {
            isShow: Boolean,
            prize_record_code:'',
            prize:''
        },
        components: {},
        watch: {
            isShow(newData, oldData) {
                _this.show = true;

                _this.submit_data.prize_record_code = _this.prize_record_code;


                _this
                    .$post('/activeprize/recordExpress',{
                    prize_record_code:_this.submit_data.prize_record_code
                })
                    .then((res) => {
                        _this.submit_data.express = res.data.express;
                        _this.submit_data.express_no = res.data.express_no;
                    })
                    .catch((err) => {});



                axios.defaults.baseURL = config.axios_normalURL; //请求base url
                _this
                    .$post('/express/getExpressList')
                    .then((res) => {
                       _this.options = res.data;
                    })
                    .catch((err) => {});
                axios.defaults.baseURL = config.axios_baseURL; //请求base url
            }
        },
        data() {
            return {
                show: false,

                options:[],

                submit_data: {
                    express: '',
                    express_no: '',
                    prize_record_code: ''
                },


                submit_rules: {
                    express_no: {
                        placeholder: '请填写快递单号',
                        rules: {
                            required: true,
                            message: '请填写快递单号',
                            regulation: 'egt_str',
                            rulesData: 0
                        }
                    },
                    express: {
                        placeholder: '请填写快递公司',
                        rules: {
                            required: true,
                            message: '请填写快递公司',
                            regulation: 'egt_str',
                            rulesData: 0
                        }
                    }
                }
            };
        },
        created() {
            _this = this;



        },
        methods: {



            // 关闭方法
            closeDialog() {
                _this.submit_data = {
                    express: '',
                    express_no: '',
                    prize_record_code: ''
                };
                _this.show = false;
            },
            // 提交
            onSubmitDig() {
                _this.$emit('onSubmit');

                _this.closeDialog();

            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>
